<div class="info-page">
  <h3>{{ modelLabel }} - Aditivo - {{ actionLabel }}</h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()" *ngIf="!isLoading">
  <div class="form-group row m-b">
    <div class="col-xs-12 col-md-5 col-lg-4">
      <label class="pb-1">Tipo de Aditivo</label>
      <ng-select id="additive_type_id" (change)="exibeCampos()" class="ng-select-alternative" [items]="tiposAditivos" bindLabel="label" bindValue="id" formControlName="additive_type_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('additive_type_id')" [erros]="fieldErros('additive_type_id')"></app-field-message>
    </div>
  </div>
  <div *ngIf="exibe_dt_end" class="form-group row m-b">
    <div class="col-xs-12 col-md-5 col-lg-4 form-group">
      <label class="pb-1">Data de término da vigência</label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_end" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }">
      <app-field-message [field]="fieldMessageRequired('dt_end')" [erros]="fieldErros('dt_end')"></app-field-message>
    </div>
  </div>
  <div *ngIf="exibe_transfer_value" class="form-group row m-b">
    <div class="col-xs-12 col-md-5 col-lg-4">
      <label class="pb-1">Novo Valor de repasse</label>
      <input type="text" id="transfer_value" class="form-control text-end" formControlName="transfer_value" (keyup)="maskCurrency($event, 'transfer_value')" />
      <app-field-message [field]="fieldMessageRequired('transfer_value')" [erros]="fieldErros('transfer_value')"></app-field-message>
    </div>
  </div>
  <div *ngIf="exibe_counterpart_value" class="form-group row m-b">
    <div class="col-xs-12 col-md-5 col-lg-4">
      <label class="pb-1">Novo Valor de contrapartida</label>
      <input type="text" id="counterpart_value" class="form-control text-end" formControlName="counterpart_value" (keyup)="maskCurrency($event, 'counterpart_value')" />
      <app-field-message [field]="fieldMessageRequired('counterpart_value')" [erros]="fieldErros('counterpart_value')"></app-field-message>
    </div>
  </div>
  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button *ngIf="canEdit && entity.id" class="btn btn-danger m-r-xxl" type="button" (click)="confirmExcluir()">Excluir</button>
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button *ngIf="canEdit" class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>

<app-system-loader [loader]="isLoading"></app-system-loader>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>